<div class="page-container">
    <span class="page-title">{{title}}</span>
    <!-- <cp-breadcrumb [breadcrumbs]="breadcrumbs"></cp-breadcrumb> -->
</div>
